import { AUTH_MODE, type IdentificationAuthMode } from '@src/domains/customers';

/** `isEmailAvailable: true` means the email is free (no account) → signup; otherwise login. */
export function decideAuthRoute(isEmailAvailable: boolean): IdentificationAuthMode {
  return isEmailAvailable ? AUTH_MODE.SIGNUP : AUTH_MODE.LOGIN;
}
